export default __webpack_public_path__ + "static/media/arlington_plaque.c37dfd50.jpg";